import { render, staticRenderFns } from "./outcome.vue?vue&type=template&id=516ed584&scoped=true&"
import script from "./outcome.vue?vue&type=script&lang=js&"
export * from "./outcome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516ed584",
  null
  
)

export default component.exports